import Header from './components/Header';
import HeroSection from './components/HeroSection';
import Footer from './components/Footer';
import './App.css';

function App() {
  const contactEmail = 'contato@quartarev.com.br';
  const domainStatus = 'ESTE DOMÍNIO ESTÁ DISPONÍVEL';
  const domainName = 'MrBrownie.com.br';

  return (
    <div className="App">
      <Header domainName={domainName} />
      <main>
        <HeroSection
          domainStatus={domainStatus}
          contactEmail={contactEmail}
        />
      </main>
      <Footer contactEmail={contactEmail} />
    </div>
  );
}

export default App;